import { render, staticRenderFns } from "./CustomerSalesService.vue?vue&type=template&id=3710b9e4&scoped=true&"
import script from "./CustomerSalesService.vue?vue&type=script&lang=js&"
export * from "./CustomerSalesService.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSalesService.vue?vue&type=style&index=0&id=3710b9e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3710b9e4",
  null
  
)

export default component.exports